import i18n from 'src/utils/translate';
import styled from 'styled-components';
import { textSmall, titleSmall } from 'styles-js/mixins/typography';

import UserLink from 'src/modules/shared/links/userLink';
import Badges from 'src/components/badges/badges';
import RelativeTime from 'src/components/relativeTime';

import signupContext from 'src/constants/signupContext';
import { Fragment } from 'react';

const Header = styled.div`
  position: relative;
  margin-bottom: 5px;

  .userlink-avatar-link {
    width: 40px;
  }
`;

const Text = styled.div`
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 50px);
  margin-left: 10px;
  padding-right: 20px;
  ${textSmall};
  line-height: ${({theme}) => theme.fontLineHeightS};
  color: ${({theme}) => theme.colorTextLight};

  .badge {
    margin-left: 10px;
  }
  time {
    display: block;
  }

  .desktop {
    @media (${({theme}) => theme.underScreenSmall}) {
      display: none;
    }

    &:before {
      content:'•';
      margin: 0 5px;
      color: ${({theme}) => theme.colorGreyLight};
      font-size: 20px;
    }
  }

  .mobile {
    @media (${({theme}) => theme.overScreenSmall}) {
      display: none;
    }
  }
  .icon {
    font-size: 17px;
  }
`;

const UserLinkAuthor = styled(UserLink)`
  ${titleSmall};
  line-height: ${({theme}) => theme.fontLineHeightSWide};

  @media (${({theme}) => theme.underScreenSmall}) {
    ${textSmall};
    font-weight: ${({theme}) => theme.fontWeightBold};
  }
`;

const UserLinkReply = styled(UserLink)`
  ${textSmall};
  color: ${({theme}) => theme.colorTextLight};
`;

const CancelEditButton = styled.button`
  position: absolute;
  top: 0;
  right: -10px;
  margin: 0;
  padding: 0 10px;
  border: none;
  color: ${props => props.theme.colorGreyDark};
  font-size: 23px;

  &:hover, &.active {
    color: ${props => props.theme.colorBlue};
  }

  @media (${props => props.theme.underScreenSmall}) {
    padding: 0 9px;
  }
`;

const ResponseHeader = ({
  author,
  canCancel,
  dateCreated,
  dateCreatedId,
  inReplyToUsername,
  isActive,
  onCancel,
  signupContextSection,
}) => (
  <Header>
    <UserLink
      avatar={true}
      avatarSize="small"
      className="userlink-avatar-link"
      isLoggedIn={isActive}
      signupContext={{
        section: signupContextSection,
        element: signupContext.element.AVATAR,
      }}
      user={author}
    />
    <Text>
      <UserLinkAuthor
        isLoggedIn={isActive}
        signupContext={{ element: signupContext.element.USER_LINK, section: signupContextSection }}
        user={author}
      />
      <Badges
        className="badge"
        roles={author.roles}
      />
      {inReplyToUsername &&
        <Fragment>
          <span className="desktop"> {i18n.t('in reply to')} </span>
          <span className="mobile icon icon-in-reply" />
          <UserLinkReply
            isLoggedIn={isActive}
            signupContext={{ element: signupContext.element.USER_LINK, section: signupContextSection }}
            user={{ username: inReplyToUsername }}
          />
        </Fragment>
      }
      <RelativeTime id={dateCreatedId} rawTime={dateCreated} />
    </Text>

    {canCancel &&
      <CancelEditButton className="btn" onClick={onCancel}>
        <span className="icon icon-cross-2" title="Close" />
      </CancelEditButton>
    }
  </Header>
);

export default ResponseHeader;
